<template>
	<div class="c-select-dropdown__menu--wrapper"  ref="select" :class="{ 'c-select-dropdown__menu--isopen': isOpen }">
		<div class="c-select-dropdown__menu--inner">
			<button class="c-select-dropdown__menu--header" aria-label="Väljare" aria-controls="c-select-dropdown-menu-items-container" @keydown.down="keyboardHandler" @keydown.esc="onToggle" @click="onToggle">
				<div class="c-select-dropdown__menu--header-content">
					<div class="c-select-dropdown__menu--headericon" v-if="icon">
						<v-icon :name="icon" size="s"></v-icon>
					</div>

					<div>
						<span v-if="showDefaultHeader">{{ defaultHeader }}</span>
						<slot v-else name="header" :active="active" :selectedItems="selectedItems"></slot>
					</div>
				</div>

				<div class="c-select-dropdown__menu--toggleicon">
					<v-icon name="icon-chevron"></v-icon>
				</div>
			</button>

			<div class="c-select-dropdown__menu--items" id="c-select-dropdown-menu-items-container" role="menu" :aria-expanded="isOpen ? 'true' : 'false'" v-show="isOpen">
				<button class="c-select-dropdown__menu--item" ref="menuItems" :key="item.id" v-for="(item, index) in items"
					@keydown.enter="onClick(item, index)" @click="onClick(item, index)">
					<slot name="item" :item="item"></slot>
					<v-icon :name="selectedIcon" size="xs" v-if="isActive(item)"></v-icon>
				</button>
			</div>

		</div>
	</div>
</template>

<script>
import VIcon from '../icon/VIcon.vue';
export default {
	name: "VSelectDropdown",
	components: {
		VIcon
	},
	props: {
		icon: {
			type: String,
			default: ''
		},
		selectedIcon: {
			type: String,
			default: 'check'
		},
		defaultHeader: {
			type: String,
			default: ''
		},
		items: {
			type: Array,
			default: () => []
		},
		selectedItems: {
			type: Array,
			default: () => []
		},
		showActiveInHeader: {
			type: Boolean,
			default: false
		},
		multiple: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			isOpen: false,
			selectedItemse: [],
			currentIndex: 0,
		}
	},
	watch: {
		isOpen: function () {
			if (this.isOpen) {
				this.$nextTick(() => {
					document.addEventListener('keydown', this.accessibleKeyboardHandler);
				})
			} else {
				document.removeEventListener('keydown', this.accessibleKeyboardHandler);
			}
		}
	},
	computed: {
		showDefaultHeader: function () {
			return !this.selectedItems || this.selectedItems.length === 0;
		},
		active: function () {
			if (!this.selectedItems || this.selectedItems.length === 0) {
				return {}
			}

			return this.selectedItems[0];
		}
	},
	methods: {
		accessibleKeyboardHandler: function(e) {
			if (e.key === 'ArrowUp') {
				this.currentIndex--;
				if (this.currentIndex + 1 === 0) {
					this.currentIndex = 0;
				}
				if (this.currentIndex >= 0) {
					this.$refs.menuItems[this.currentIndex].focus();
				}
			}
			if (e.key === 'ArrowDown') {
				if (this.currentIndex === this.$refs.menuItems.length) {
					return;
				}
				this.$refs.menuItems[this.currentIndex].focus();
				this.currentIndex++;
			}
			if (e.key === 'Escape') {
				this.isOpen = false;
			}
		},
		isActive: function (item) {
			return this.selectedItems.includes(item);
		},
		onToggle: function () {
			this.isOpen = !this.isOpen;
		},
		keyboardHandler: function () {
			this.isOpen = true;
		},
		onClick: function (item, index) {
			if (this.multiple) {
				if (this.selectedItems.includes(item)) {
					const itemIndex = this.selectedItems.indexOf(item);
					this.selectedItems.splice(itemIndex, 1);
				} else {
					this.selectedItems.push(item);
				}
			} else {
				this.selectedItems.splice(0, this.selectedItems.length);
				this.selectedItems.push(item);
			}

			this.$emit('onItemSelected', item, this.selectedItems, index);
		}
	}
};
</script>
